import { render } from "./DeviationsTable.vue?vue&type=template&id=608deb68&ts=true"
import script from "./DeviationsTable.vue?vue&type=script&lang=ts"
export * from "./DeviationsTable.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./DeviationsTable.vue?vue&type=style&index=0&id=608deb68&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QTable,QInput,QPopupProxy,QDate,QIcon});
